import React, { Component } from 'react';
import { Table, Divider, Tag, Icon, Button, Card, Row, Col } from 'antd';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'antd/dist/antd.css';


export default class Card5 extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };

    }

    render() {
        const { title, detail, deliveredTextMessage, Text, Rich } = this.props;
        return (
            <Card className="card1" >
                <Row gutter={16} style={{ marginTop: 30 }}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={16} type="flex" justify="center">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div className="card1-head">
                                    <h1>{title}</h1>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={16} type="flex" justify="center" style={{ marginTop: 10, textAlign: 'center' }}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <label className="ants-gray-low">{detail}</label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className="progress progress-xs" style={{ backgroundColor: '#D95118' }}>
                            <div id="deliveryProgress" className="progress-bar" role="progressbar" style={{ width: deliveredTextMessage + '%', backgroundColor: '#0d1e36' }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </Col>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <div className="text-muted">
                            <lable>Text <span>{Text}</span></lable>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <div className="text-muted" style={{ textAlign: "right" }}>
                            <label>Rich <span>{Rich}</span></label>
                        </div>
                    </Col> */}
                </Row>
            </Card>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Ants/Card/Card5.js